import { autorun } from "mobx";

/**
 * Keep the store in sync with the window location hash.
 */
class Router {
  constructor(store) {
    this.store = store;
    this.updateStoreToMatchHash();
    this.listen();
    autorun(() => {
      this.updateHashToMatchStore();
    });
  }

  currentHash() {
    // removes the # from the hash
    if (typeof window === `undefined`) {
      return null;
    }
    return window.location.hash.substr(1);
  }

  hashForStepIndex(stepIndex) {
    return this.store.steps[stepIndex].name;
  }

  stepIndexForHash(hash) {
    for (let index = 0; index < this.store.steps.length; index += 1) {
      const step = this.store.steps[index];
      if (step.name === hash) {
        return index;
      }
    }
    return 0;
  }

  updateStoreToMatchHash() {
    // console.log('would update store to match hash:', this.currentHash());
    // console.log('step index:', this.stepIndexForHash(this.currentHash()));
    this.store.setSelectedStepIndex(this.stepIndexForHash(this.currentHash()));
  }

  updateHashToMatchStore() {
    if (typeof window === `undefined`) {
      return;
    }
    window.location.hash = this.hashForStepIndex(this.store.selectedStepIndex);
  }

  listen() {
    if (typeof window === `undefined`) {
      return;
    }
    window.addEventListener(`hashchange`, () => {
      this.updateStoreToMatchHash();
    });
  }
}
export default Router;



// WEBPACK FOOTER //
// ./src/byos/logic/Router.js